import classNames from 'classnames'
import React, { FC } from 'react'
import {
  CNFProductCard,
  ProductCardProps
} from '@modules/showroom/productCollection/enhancedView/component/CNFProductCard'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  cnfLandscapeCard: {
    '& .product-media.product-media-card': {
      height: 240,
      '& img': {
        height: '100%'
      }
    },
    '&.product-card': { display: 'flex', flexDirection: 'row' },
    '&>:nth-child(1)': {
      width: '50%',
      flex: '1 1 50%'
    },
    '&>:nth-child(2)': {
      height: '100%',
      flex: '1 1 50%',
      alignItems: 'flex-start',
      paddingLeft: '15px'
    }
  }
}))

const CNFLandscapeProductCard: FC<ProductCardProps> = props => {
  const classes = useStyles()
  return (
    <CNFProductCard
      {...props}
      isLeftAlined={true}
      isCompressedCard={true}
      cardCss={classNames(classes.cnfLandscapeCard, props.cardCss)}
    />
  )
}
export default CNFLandscapeProductCard
